
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vyhledavani",
      function () {
        return require("private-next-pages/vyhledavani.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vyhledavani"])
      });
    }
  